<div>
  <div>
    <div class="custom-form-field">
      <input
        id="{{ id }}"
        [type]="type"
        name="Generic-input"
        [formControl]="formCtrl"
        [placeholder]="placeholder"
        class="custom-input"
        [ngClass]="{ 'has-error': formCtrl.touched && formCtrl.invalid }"
        [attr.data-testid]="dataTestId"
      />
    </div>
  </div>
  @for (message of errorMessages; track message) {
    <div class="error-message-container">
      @if (formCtrl.touched && formCtrl.hasError(message.name)) {
        <ng-container>
          <app-custom-error [errorMessage]="message.value" id="{{ message.name }}"></app-custom-error>
        </ng-container>
      }
    </div>
  }
</div>
